<template>
  <span class="message-text-content" :inner-html.prop="messageText"></span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  },

  computed: {
    messageText () {
      let message = this.text || ''
      message = message.replace(/\*(.*?)\*/g, '<b>$1</b>') // *bold*
      message = message.replace(/_(.*?)_/g, '<i>$1</i>') // _italic_
      message = message.replace(/~(.*?)~/g, '<s>$1</s>') // ~strike~
      message = message.replace(/```(.*?)```/g, '<span class="mono">$1</span>') // ```monospace```
      return message
    }
  }
}
</script>

<style lang="scss">
  .message-text-content {
    font-size: 16px;
    line-height: 19px;
    white-space: pre-wrap;

    .mono {
      background-color: #f5f5f5;
      font-family: monospace;
      padding: 0 .2em;
    }

    s {
      text-decoration: line-through;
    }
  }
</style>
